module.exports = ReactRouter;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 5
// module chunks = 0 2